<template>
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.2242 12.8686L8.54422 8.18859C8.32422 7.96859 8.21422 7.68859 8.21422 7.34859C8.21422 7.00859 8.32422 6.72859 8.54422 6.50859C8.76422 6.28859 9.04422 6.17859 9.38422 6.17859C9.72422 6.17859 10.0042 6.28859 10.2242 6.50859L15.7442 12.0286C15.8642 12.1486 15.9492 12.2786 15.9992 12.4186C16.0492 12.5586 16.0742 12.7086 16.0742 12.8686C16.0742 13.0286 16.0492 13.1786 15.9992 13.3186C15.9492 13.4586 15.8642 13.5886 15.7442 13.7086L10.2242 19.2286C10.0042 19.4486 9.72422 19.5586 9.38422 19.5586C9.04422 19.5586 8.76422 19.4486 8.54422 19.2286C8.32422 19.0086 8.21422 18.7286 8.21422 18.3886C8.21422 18.0486 8.32422 17.7686 8.54422 17.5486L13.2242 12.8686Z"
            fill="white" />
    </svg>
</template>
<script>
export default {
    name: "NextBtnWhite",
};
</script>
<style lang="scss"></style>